export const BLOCK_NAME = 'b-expansion-panels'

export const ANIMATION_DURATION = 200
